import { type RouteLocationNormalizedGeneric } from 'vue-router';

import { useAuth } from '@/hooks/auth/use-auth';

// https://router.vuejs.org/guide/advanced/meta.html#TypeScript
export async function authGuard(to: RouteLocationNormalizedGeneric) {
  const { waitForAuthSync, isAuthenticated } = useAuth();
  await waitForAuthSync.value.promise;
  if (to.meta.authRequired && !isAuthenticated.value) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    return {
      path: '/',
      // save the location we were at to come back later
      query: { redirect: to.fullPath },
    };
  }
}
